<template>
    <div>
        <el-input v-model="buscar" placeholder="Buscar producto" class="w-100 br-20" @input="buscarProductos"/>
    </div>    
</template>
<script>
import CedisKits from '~/services/cedis/cedis_kits'
export default {    
    props: {
       adicional:{
           type: Object,
            default() {
                return {}
            }
       }
    },
    data(){
        return{
            buscar:''
        }
    },
    methods:{
        async buscarProductos(){
            try{
                if(this.buscar.length>=3){
                    
                    let loading = this.$loading(
                        {
                            lock: true,
                            target:`#loading-crear-kit`
                        });

                    let datos = {
                        text : this.buscar,
                        adicional: this.adicional
                    }

                    const { data } = await CedisKits.BuscarCedisProductos(this.$route.params.id_cedis,datos)
                    this.$emit("productosObtenidos",data)
                    loading.close()
                                       
                }
            } catch (error){
                this.error_catch(error)
            }
        }      
    }
}
</script>

<style lang="scss" scoped>

</style>
